
import { SvgIcon, SvgIconProps } from "@mui/material";
    
export const NoteIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M6.5 2.5v3M10.167 2.5v3"/><rect width="18" height="17" x="3" y="4" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" rx="2"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16.5 17h-9M16.5 13.5h-9M12 10H7.5M13.833 2.5v3M17.5 2.5v3"/></svg>
  </SvgIcon>
);
